import * as core from '../../../../../../../core'

import { query } from './affiliates-table.query'

export const RESOURCE = {
  payload: {
    alias: 'affiliates.table',
    description:
      'Table Showing Affiliates and all summary statistics for an Assessment.',
    name: 'Affiliates Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
